module.exports = __webpack_public_path__ + "img/emo_14.913e2f3d.gif";